import Vue from 'vue'
import Router from 'vue-router'
import LoginPage from '../views/LoginPage'
import Home from '../views/Home'
import WithdrawConfirmation from '../components/study/WithdrawConfirmation'
import ErrorMessage from '../views/ErrorMessage'
import Identifier from '../components/study/BaselineInput'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      redirect: { name: 'Login' }
    },
    {
      path: '/error',
      name: 'ErrorMessage',
      component: ErrorMessage
    },
    // {
    //   path: '/identifier',
    //   name: 'Identifier',
    //   component: Identifier
    // },
    {
      path: '/login',
      name: 'Login',
      component: LoginPage
    },
    {
      path: '/withdrawconfirmation',
      name: 'WithdrawConfirmation',
      component: WithdrawConfirmation
    },
    {
      path: '/home',
      name: 'Home',
      component: Home
    },
    {
      path: '/*',
      redirect: { name: 'Login' }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js